<template>
    
 <div class="" v-if="question_details.length">
   <vs-collapse class="import-collapse p-0">
    <vs-collapse-item>
      <div slot="header">
        <h4 style="padding:10px;margin:5px auto;display: inline-block;" class="text-center">Imported Questions</h4>
      
        <vs-tooltip
        class="mr-10"
        style="margin:5px;float: right;"
        text="Remove all imported questions" 
        position="top"
        color="rgb(234, 84, 85)"
        >
          <vs-button
          class="mb-2"
          color="danger" type="filled" icon-pack="feather" icon="icon-trash"
          @click="removeImportedQuestions">
          </vs-button>
        </vs-tooltip>    
      </div>
      <vs-divider />

      <vs-card v-for="(eachQuestion,index) in question_details" :key="index">
          <div class="question_info" v-if="eachQuestion.questions != null">
          
          <vs-tooltip
          text="Remove this imported question" 
          position="top"
          color="orange"
          style="margin:5px;float: right;"
          >
            <vs-button
            class="mb-2"
            color="primary" type="filled" icon="remove"
            @click="removeIndividualQuestions(index)">
            </vs-button>
          </vs-tooltip>
          <vs-divider />

            <h5>{{index + 1}}. {{eachQuestion.questions.title}}</h5>

            <vs-divider />
            <p><b>Question Type : </b>{{eachQuestion.questions.input_type_id_obj.label}}</p>

            <vs-divider />
            <p><b>Points : </b>{{eachQuestion.questions.point}}</p>

            <div class="" v-if="eachQuestion.questions.questions_options.length > 0">
            <vs-divider />
            <p><b>Options :</b></p>
            <ul>
              <li class="question_options" v-for="(options,index) in eachQuestion.questions.questions_options" :key="index">
                <p>{{index + 1}}. {{options.option_name}}<span v-if="options.is_answer == true"> - <b><i>Correct Answer</i></b></span></p>
              </li>
            </ul>
            </div>

            <div class=""  v-for="(options,index) in eachQuestion.questions.questions_options" :key="index">
            <vs-divider />
            <p v-if="options.is_answer == true"><b>Answer : </b> {{options.option_name}}</p>
            </div>

            <vs-divider />
            <p><b>Feedback : </b> {{eachQuestion.questions.feedback}}</p>

            <vs-divider />
            <p><b>Links : </b> 
            <!-- {{eachQuestion.questions.links}} -->
            </p>
            
            <!-- Links Preview Component Start -->
            <LinkPreviewComponent
            :question_detail="eachQuestion.questions"
            type="Import">
            </LinkPreviewComponent>
            <!-- Links Preview Component End -->


            <!-- Attatched Files Preview Start -->
            <vs-row v-if="eachQuestion.questions.files && eachQuestion.questions.files.length > 0"> 
                  <vs-divider />
                  <vs-col>
                    <div class="">
                      <h5><b>Attached files</b></h5>
                      <br>
                    <div class="" v-for="(files, index) in eachQuestion.questions.files" :key="index">
                      <b><h5>File {{index + 1}}</h5></b><br>
                      <div v-if="files.file !== null">
                    <!-- {{files.file}} -->

                    <!-- Existing Files Preview -->
                    <div
                      class=""
                      v-if="files.file.file_type.includes('image')"
                    >
                    <p>File Name : {{files.file.file_name}}</p>
                    <p>File Type : {{files.file.file_type}}</p>
                    <br>
                      <img
                        class="fileUpload-image
                        "
                        :src="files.file.file_path"
                      />
                      <!-- <input type="button" @click="downloadFile(question_detail.file.file_path)" value="Doenload"> -->
                    <vs-divider />
                    </div>

                    <div
                      class=""
                      v-if="files.file.file_type.includes('video')"
                    >
                    <p>File Name : {{files.file.file_name}}</p>
                    <p>File Type : {{files.file.file_type}}</p>

                      <video width="320" height="240" controls>
                        <source
                          :src="files.file.file_path"
                          type="video/mp4"
                        />
                        <source
                          :src="files.file.file_path"
                          type="video/ogg"
                        />
                        Your browser does not support the video tag.
                      </video>
                      <!-- <p>Video File</p> -->
                      <vs-divider />
                    </div>

                    <div
                      class=""
                      v-if="files.file.file_type.includes('audio')"
                    >
                    <p>File Name : {{files.file.file_name}}</p>
                    <p>File Type : {{files.file.file_type}}</p>
                    <br>
                      <audio controls>
                        <source
                          :src="files.file.file_path"
                          type="audio/ogg"
                        />
                        <source
                          :src="files.file.file_path"
                          type="audio/mpeg"
                        />
                        Your browser does not support the audio element.
                      </audio>
                      <!-- <p>Audio File</p> -->
                      <vs-divider />
                    </div>

                      </div>
                    </div>
                  </div>
                  </vs-col>
                </vs-row>
                <!-- Attatched Files Preview Start -->


          </div>
      </vs-card>
    </vs-collapse-item>
   </vs-collapse>
  
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { Tag } from '@/mixins/tag/tag'
import QuestionModal from '../../questions/question-modal.vue'
import LinkPreviewComponent from '@/components/LinkPreview/LinkPreviewComponent'

// import {deleteAssignmentOrQuesion} from '@/api/course-builderapi'

export default {
  name:'ImportedQuestionsComponent',
  components:{
    vSelect,
    QuestionModal,
    LinkPreviewComponent
  },
  mixins: [Tag],
  props: {
    question_details:{
      type:Array,
      default:() => []
    },
    lesson_file_index:{
      default:null
    }
  },
  computed: {
 
  },
  created () {
  },

  data () {
    return {
    }
       
  },
  methods:{
    removeImportedQuestions () {
      const allQuestion = {
        lesson_file_index:this.lesson_file_index,
        type:'allDelete'

      }
      this.$emit('removeImportedQuestionsEvent', allQuestion)
    },


    removeIndividualQuestions (index) {    
      
      const SingleQuestion = {
        removeIndex:index,
        lesson_file_index:this.lesson_file_index,
        type:'single'

      }

      this.$emit('removeImportedQuestionsEvent', SingleQuestion)
    }
    // async deletingAssignmentOrQuestion (id, index) {  
    //   try {
    //     const customer_id = this.$store.getters.customerId

    //     const payload = {
    //       id
    //     }

    //     const data = await deleteAssignmentOrQuesion(customer_id, payload)
    //     
    //     this.$vs.notify({
    //       title: 'Success',
    //       text: 'Question Deleted Successfully',
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'danger',
    //       time: 3000
    //     })
    //     this.question_details.splice(index, 1)

    //     // this.assignmentDataList.findIndex(ele => {
    //     //   ele.id
    //     // })
    //   } catch (error) {
    //     
    //   }
    // }
   
  }
  // beforeDestroy () {
  //   
  //   setTimeout(() => {
  //     
  //   }, 1000)
  //   // this.question_details.length = 0
  // }
    
}
</script>


<style scoped>
.question_info{
  padding:20px
}
.question_info p{
  font-size:15px;
}

.fileUpload-image {
  max-width: 200px;
  box-shadow: 0px 0px 3px #b8b3b385;
  border-radius: 4px;
}

.question_options p{
  margin:5px auto;
}

</style>

<style>
  .import-collapse .vs-collapse-item--header {
    padding: 0;
  }
  .import-collapse .vs-collapse-item--content {
    width: 100%;
  }
  .import-collapse .vs-collapse-item--icon-header .vs-icon {
    font-size: 1.5rem;
  }
</style>